import { FunctionComponent } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { Unauthorized } from './Unauthorized';
import { useLocalAuth, isLocallyAuthenticated } from '../../auth/LocalAuthService';
import { Redirect } from 'react-router-dom';

const CheckAuthorization: FunctionComponent = ({ children }) => {
    if (useLocalAuth()) {
        if (isLocallyAuthenticated()) {
            return <>{children}</>;
        }
        return <Redirect to="/login" />;
    }

    return (
        <>
            <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Unauthorized />
            </UnauthenticatedTemplate>
        </>
    );
};

export default CheckAuthorization;
